import React from "react";

import { badgeVariants } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const STATUS_EMOJI = {
  pending: "○",
  in_progress: "⏳",
  validated: "✓",
  moderation_blocked: "🔔",
};
const STATUS_COLOR = {
  pending: "text-gray-400",
  in_progress: "text-amber-500",
  validated: "text-green-600",
  moderation_blocked: "text-red-600",
};

export default function BDChapterPills({ chapters, activeIndex, onSelect }) {
  return (
    <div className="space-y-2">
      {chapters.map((c) => {
        const isActive = c.chapter_index === activeIndex;
        const isValidated = Boolean(c.status === "validated" || c.validated || c.validated_at);
        const validatedOutdated = Boolean(c.validated_outdated);
        return (
          <button
            key={c.chapter_index}
            onClick={() => onSelect(c.chapter_index)}
            aria-current={isActive ? "page" : undefined}
            aria-pressed={isActive}
            className={`w-full text-left px-3 py-2 rounded border transition ${
              isActive
                ? "bg-orange-100 border-orange-500 ring-1 ring-orange-300 shadow-sm"
                : "bg-white border-gray-200 hover:bg-gray-50"
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium">
                {c.chapter_index === 6 ? "Planche complète" : `Ch.${c.chapter_index}`}
              </span>
              {validatedOutdated ? (
                <span
                  className={cn(
                    badgeVariants(),
                    "bg-amber-100 text-amber-800 border-amber-200 hover:bg-amber-100"
                  )}
                  title="La version validée n'est pas la plus récente — ouvre le chapitre pour choisir"
                >
                  ⚠ Pas la dernière
                </span>
              ) : isValidated ? (
                <span className={cn(
                  badgeVariants(),
                  "bg-green-100 text-green-800 border-green-200 hover:bg-green-100"
                )}>
                  ✓ Validée
                </span>
              ) : (
                <span className={STATUS_COLOR[c.status] || "text-gray-400"}>
                  {STATUS_EMOJI[c.status] || "○"}
                </span>
              )}
            </div>
            {c.n_versions > 0 && (
              <p className="text-xs text-gray-500 mt-1">{c.n_versions} version(s)</p>
            )}
          </button>
        );
      })}
    </div>
  );
}
